import type { GlobalRuntimeSettings } from '../../../services/globalSettings.service';

export const isBillingPricingConfigValid = (config: GlobalRuntimeSettings): boolean => {
  const checks: [keyof GlobalRuntimeSettings, (value: number) => boolean][] = [
    ['billingCreditsPerUsd', (value) => Number.isInteger(value) && value > 0],
    ['billingOverheadFactor', (value) => value >= 1],
    ['billingTargetMargin', (value) => value >= 0],
    ['billingPaymentFeeRate', (value) => value >= 0 && value < 1],
    ['billingTaxRate', (value) => value >= 0 && value < 1],
    ['billingFxBuffer', (value) => value >= 0],
    ['billingMinUtilization', (value) => value > 0 && value <= 1],
    ['billingReportMaxDays', (value) => Number.isInteger(value) && value > 0],
    ['billingUnitCostWindowDays', (value) => Number.isInteger(value) && value > 0],
    ['billingCostVarianceMinAbsUsd', (value) => value >= 0],
    [
      'billingCostVarianceThresholdPercent',
      (value) => Number.isInteger(value) && value >= 0 && value <= 100,
    ],
    ['billingFallbackImageUsd', (value) => value >= 0],
  ];
  return (
    checks.every(([field, validate]) => {
      const value = Number(config[field]);
      return Number.isFinite(value) && validate(value);
    }) && config.billingPaymentFeeRate + config.billingTaxRate < 1
  );
};
